import {Directive, ElementRef, Input, Renderer2} from '@angular/core';
import {MessageService} from "../providers/message-service";
import {PushRepository} from "../repositories/push-repository";

@Directive({
    selector: '[badges]',
    host: {'(click)': 'onClick($event)'},
    providers: [PushRepository]
})
export class BadgeDirective {


    //EXCLUIR - BRUNO - PASSAR PARA DENTRO DA DIRECTIVA O CSS
/*

//Directiva badge.ts - não esta utilizando serve para sum de Badge, qdo vai entrando em janelas
.avatar-badge-wrap {
    overflow: visible !important;
    position: relative;
}

.avatar-badge-bd {
    position: absolute;
    right: -13px;
    bottom: -13px;
    height: 23px;
    padding: 5px;
    border-radius: 50px;
}

 */


    @Input('badges') badges: string[] = []; // só recebe o default '' caso a propriedade seja [badge]="", se for apenas hotkeys ou hotkeys="" não recebe (e se estiver omitida?)
    @Input('badges-count') badgesCount: number = 0;
    @Input('badges-clear') badgesClear: boolean = false;

    private _element: HTMLElement;
    private _elementIonBadge: HTMLElement;

    constructor(public element: ElementRef, public renderer: Renderer2,
                public messageService: MessageService, public pushRepository: PushRepository) {

        this._element = element.nativeElement;

        // quando vem push
        this.messageService.get('badge.pushed').subscribe(() => this._setByStorage());

        // quando clica em badge exterior
        this.messageService.get('badge.update').subscribe(() => this._setByStorage());

    }

    ngAfterViewInit() { // não precisa de setTimeout

        this._elementIonBadge = this._element.querySelector('ion-badge');
        this._render(); // garante que inicia vermelho

        // quando inicia o componente
        this._setByStorage();

    }

    onClick(event) {

        // é item final / não é grupo
        // esse if bloqueia de uma sub aba limpar aba superior
        if (this.badges.length == 1) {

            this.pushRepository.badgeDel(this.badges).subscribe();

        }

        //this.badgesCount = 0;
        //this._render();

    }

    private _setByStorage() {

        this.pushRepository.badgeCount(this.badges)
            .subscribe(count => {

                this.badgesCount = count;
                this._render();

            });

    }

    private _render(): void {

        if (this._elementIonBadge) {

            if (this.badgesCount && this._elementIonBadge) {
                this.renderer.removeClass(this._elementIonBadge, 'display-none');
                this.renderer.addClass(this._elementIonBadge, 'display-block');
            }
            else {
                this.renderer.removeClass(this._elementIonBadge, 'display-block');
                this.renderer.addClass(this._elementIonBadge, 'display-none');
            }

            if (!this.badgesClear) {
                this._elementIonBadge.innerHTML = this.badgesCount.toString();
            }

        }

    }


    /* USAGE EXEMPLE

                <button [badges]="['sem-parar']" [badges-clear]="true" (click)="selectTab(4)" [ngClass]="{'selected-button': tab == 4}">
                    <span class="display-block" style="height: 30px; line-height: 30px;">
                        <ion-icon name="ios-card"></ion-icon>
                        <ion-badge mode="ios" color="CorVerm"></ion-badge>
                    </span>
                    <p class="margin-top-0 font-lighter font-size-11">Payout</p>
                </button>

                <button [badges]="['seguidor', 'seguindo', 'chaveco']" (click)="selectTab(0)" [ngClass]="{'selected-button': tab == 0}">
                    <span class="display-block" style="height: 30px; line-height: 30px;">
                        <ion-icon name="ios-person"></ion-icon>
                        <ion-badge mode="ios" color="CorVerm"></ion-badge>
                    </span>
                    <p class="margin-top-0 font-lighter font-size-11">Perfil</p>
                </button>
     */
}



// WEBPACK FOOTER //
// ./src/directives/badge.ts